import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Plus, Save } from 'lucide-react';
import { CATEGORIES } from './constants';
import { EvidenceRows, AssessmentPicker, TagChips } from './shared';

export const QuickAnalysisForm = ({
  form, setForm, tagsById, tsRef, saving, onOpenTags, onToggleTag, onSave,
}) => (
  <Card data-testid="quick-analysis-card">
    <CardHeader className="pb-2"><CardTitle className="text-base flex items-center gap-2">
      <Plus className="w-4 h-4" /> Quick Analysis
    </CardTitle></CardHeader>
    <CardContent className="space-y-3">
      <div className="grid grid-cols-2 gap-3">
        <div>
          <Label className="text-xs">Timestamp</Label>
          <Input ref={tsRef} placeholder="67:39" value={form.timestamp}
                 onChange={e => setForm(f => ({ ...f, timestamp: e.target.value }))}
                 data-testid="qa-timestamp" />
        </div>
        <div>
          <Label className="text-xs">Period / Part</Label>
          <Input placeholder="Part 3" value={form.period}
                 onChange={e => setForm(f => ({ ...f, period: e.target.value }))}
                 data-testid="qa-period" />
        </div>
      </div>
      <div>
        <Label className="text-xs">Category</Label>
        <Select value={form.category} onValueChange={v => setForm(f => ({ ...f, category: v }))}>
          <SelectTrigger data-testid="qa-category"><SelectValue placeholder="Select category" /></SelectTrigger>
          <SelectContent>
            {CATEGORIES.map(c => <SelectItem key={c} value={c} data-testid={`qa-cat-${c}`}>{c}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      <div>
        <div className="flex items-center justify-between mb-1">
          <Label className="text-xs">Development Tags</Label>
          <Button type="button" size="sm" variant="outline" onClick={onOpenTags} data-testid="qa-open-tags">
            Select tags
          </Button>
        </div>
        <TagChips ids={form.development_tag_ids} tagsById={tagsById} onRemove={onToggleTag} />
      </div>
      <div>
        <Label className="text-xs">Assessment</Label>
        <AssessmentPicker value={form.assessment} onChange={v => setForm(f => ({ ...f, assessment: v }))} />
      </div>
      <div>
        <Label className="text-xs">Observation</Label>
        <Textarea rows={3} placeholder="Describe the moment…" value={form.observation}
                  onChange={e => setForm(f => ({ ...f, observation: e.target.value }))}
                  data-testid="qa-observation" />
      </div>
      <div>
        <Label className="text-xs">Evidence (optional)</Label>
        <EvidenceRows items={form.evidence} setItems={items => setForm(f => ({ ...f, evidence: items }))} testidPrefix="qa-evidence" />
      </div>
      <div className="flex gap-2 pt-1">
        <Button onClick={() => onSave(false)} disabled={saving} data-testid="qa-save">
          <Save className="w-4 h-4 mr-1" /> Save
        </Button>
        <Button variant="outline" onClick={() => onSave(true)} disabled={saving} data-testid="qa-save-add">
          Save & Add Another
        </Button>
      </div>
    </CardContent>
  </Card>
);

export default QuickAnalysisForm;
